import { useBreakpointValue } from "@chakra-ui/react"

export const useCarouselAlignment = (
  alignmentXs: number,
  alignmentMd: number,
  alignment: number
) => {
  const getCarouselAlignment = (alignment: number) => {
    switch (alignment) {
      case 1:
        return 2
      case 2:
        return 1
      default:
        return alignment
    }
  }

  const contentAlignment = useBreakpointValue({
    base: alignmentXs,
    md: alignmentMd,
    lg: alignment,
  })

  const carouseAlignment = useBreakpointValue({
    base: getCarouselAlignment(alignmentXs),
    md: getCarouselAlignment(alignmentMd),
    lg: getCarouselAlignment(alignment),
  })

  return { carouseAlignment, contentAlignment }
}
